<template>
  <section class="flex flex-col md:flex-row justify-between">
    <form class="common__box form__container w-full md:w-1/3">
      <h2 class="font__large">Bot Configuration</h2>

      <h3 class="font__normal mt-2">Configure your Organisation Bot</h3>
      <div class="bot__name">
        <label class="font__normal">Bot name</label>
        <input
          v-model="form.name"
          class="font__normal"
          type="text"
          placeholder="A.L.F.R.E.D"
        />

        <caption class="font__small text-left">
          Adaptive Learning For Relevant Education and Development
        </caption>
      </div>

      <div class="bot__mascot">
        <label class="font__normal">Bot Mascot</label>

        <div class="bot__mascot__options">
          <!-- <img class="" src="@/assets/images/marketplace/alfred.png" alt="" /> -->
          <img
            class=""
            src="../../../../assets/images/marketplace/alfred.png"
            alt=""
          />
        </div>
      </div>

      <div class="bot__model">
        <label class="font__normal">Model</label>

        <select
          v-model="form.model"
          class="font__normal"
          name="model"
          id="model"
        >
          <option class="hidden" value="" disabled selected>Model</option>
          <option value="gpt-3.5-turbo">GPT 3</option>
          <option value="gpt-4">GPT 4</option>
        </select>

        <caption class="font__small text-left">
          1 message using gpt-3.5-turbo costs___
        </caption>
        <caption class="font__small text-left">
          1 message using gpt-4 costs___
        </caption>
      </div>

      <div class="bot__name">
        <label class="font__normal">Bot name</label>
        <input
          v-model="form.initial_msg"
          class="font__normal"
          type="text"
          placeholder="Act as my assistant"
        />

        <caption class="font__small text-left">
          Give Your First Message Here.
        </caption>
      </div>

      <div class="bot__upload">
        <label class="font__normal"
          >Upload additional documents to train the bot on chat responses.
          (Optional)</label
        >

        <div class="upload__box relative">
          <input
            type="file"
            name="myfile"
            id="file"
            accept=".doc,.docx,.pdf"
            ref="file"
            class="h-full w-full absolute none"
            @change="uploadFile"
            @dragover.prevent
            @dragleave.prevent
            @drop="dropHandler"
          />
          <img class="" src="@/assets/images/marketplace/plus.svg" alt="" />

          <label class="font__small">Drop your files here</label>

          <caption class="font__normal">
            <a>Browse file</a>
            from your computer
          </caption>
        </div>
      </div>

      <vs-button
        :disabled="isLoading"
        class="font__normal cursor-pointer"
        @click="saveConfiguration"
      >
        Save Configuration
      </vs-button>
    </form>
    <ChatBotMessages :chatBot="this.chatBot" />
  </section>
</template>

<script>
// import DataViewSidebar from '../DataViewSidebar.vue'
import constants from "@/constants";
import axios from "axios";
import ChatBotMessages from "./ChatBotMessages.vue";

export default {
  components: {
    ChatBotMessages,
  },
  data() {
    return {
      constants,
      form: {
        name: "",
        initial_msg: "",
        model: "",
      },
      isLoading: false,
      chatBot: {
        name: "ALFRED",
        _id: "64836af7abb716e0ee982748",
        model: "gpt-3.5-turbo",
        messages: [{ role: "system", content: "👋 Hello, I’m ALFRED!" }],
      },
    };
  },
  computed: {
    // currentPage() {
    //   if (this.isMounted) {
    //     return this.$refs.table.currentx;
    //   }
    //   return 0;
    // },
  },
  watch: {
    // searchValue(newVal) {
    //   if (newVal === "") {
    //     this.searchedUserArray = this.reviewUserRequest;
    //   }
    // },
  },
  methods: {
    uploadFile(event) {
      this.selectedFile = event.target.files[0];
      this.sendRequest();
    },
    dropHandler(event) {
      event.preventDefault();
      this.selectedFile = event.dataTransfer.files[0];
      this.sendRequest();
    },
    async sendRequest() {
      if (!this.selectedFile) return;

      const formData = new FormData();
      formData.append("train", this.selectedFile);

      try {
        const response = await axios.post(
          "https://agent.neolen.xyz/api/chatbot/upload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(response);
      } catch (error) {
        console.error(error);
      }
    },
    async saveConfiguration() {
      try {
        this.isLoading = true; // flag to indicate that saving is in progress
        const response = await axios({
          method: "post",
          url: "https://agent.neolen.xyz/api/chatbot/create",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            train_data: {
              weblinks: [],
              text: "",
            },
            setting: {
              name: this.form.name,
              initial_msg: this.form.initial_msg,
              model: this.form.model,
            },
          },
        });
        this.chatBot = response.data.chatbot;
      } catch (error) {
        // handle the error here
        console.error(error);
      } finally {
        this.isLoading = false; // reset the loading flag
      }
    },
  },
  mounted() {
    // this.isMounted = true;
    // if (this.orgData && this.orgData._id) {
    //   this.$store.dispatch("organization/fetchAllEmployees", {
    //     organizationId: this.orgData._id,
    //   });
    //   this.getEmployeeRequest(this.orgData._id);
    // }
  },
};
</script>

<style lang="scss" scoped>
.common {
  &__box {
    padding: 2em;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0px 30px 40px 20px rgba(99, 132, 227, 0.1);
  }
}
.form__container {
  display: grid;
  grid-auto-flow: row;
  justify-content: start;
  place-content: start;
  width: 35em;

  .font__large {
    font-size: 1.5em;
  }
  .font__normal {
    font-size: 1.25em;
  }
  .font__small {
    font-size: 1em;
  }

  h2 {
    color: #101828;
    font-weight: 600;
  }
  h3 {
    color: #798ba0;
    font-weight: 500;
  }

  .bot__type {
    display: grid;
    place-content: start;
    justify-content: start;
    grid-auto-flow: column;
    gap: 1em;
    margin: 0.5em 0em;

    &__item {
      position: relative;
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      place-content: start;

      input {
        appearance: none;
        height: 15px;
        width: 15px;
        border: solid 1px #f29300;
        border-color: #f29300;
        border-radius: 50%;
        background-color: #ffffff;
        margin-right: 0.3em;
        display: grid;
        place-content: center;
        position: relative;
        cursor: pointer;
      }

      input:before {
        content: " ";
        position: absolute;
        z-index: 1;
        top: 1px;
        bottom: 1px;
        left: 1px;
        right: 1px;
        border-radius: 50%;
        border: 2px solid #ffffff;
      }

      input:checked {
        background-color: #f29300;
      }

      label {
        color: #798ba0;
        font-weight: 500;
        padding-top: 0.25em;
        cursor: pointer;
      }
    }
  }

  .bot__name {
    display: grid;
    place-content: start;
    grid-auto-flow: row;
    margin: 0.5em 0em;
    width: 100%;
    grid-template-columns: repeat(1, minmax(0, 1fr));

    label {
      color: #363939;
      font-weight: 500;
      margin-bottom: 0.5em;
    }

    input {
      color: #8e9090;
      font-weight: 500;
      padding: 0.8em;
      border-radius: 0.3em;
      border: solid 1px #8e9090;
      width: 100%;
      grid-column: span 1 / span 1;
    }

    caption {
      color: #57595a;
      font-weight: 400;
    }
  }

  .bot__mascot {
    display: grid;
    place-content: start;
    grid-auto-flow: row;
    margin: 0.5em 0em;

    label {
      color: #363939;
      font-weight: 500;
      margin-bottom: 0.5em;
    }

    &__options {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5em 2em;

      img {
        width: 80px;
        height: 80px;
        padding: 0.5em;
        border: dashed 1px #d2d3d3;
        background-color: #ffffff;
        display: grid;
        place-content: center;
        border-radius: 0.5em;
        margin-bottom: 1em;
      }
    }
  }

  .bot__model {
    display: grid;
    place-content: start;
    grid-auto-flow: row;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin: 0.5em 0em;

    label {
      color: #363939;
      font-weight: 500;
      margin-bottom: 0.5em;
    }

    select {
      color: #8e9090;
      font-weight: 500;
      padding: 1em;
      border-radius: 0.3em;
      border: solid 1px #8e9090;
      background-color: #ffffff;
      grid-column: span 1 / span 1;
      margin-bottom: 0.5em;

      option {
        color: #363939;
      }
    }

    caption {
      color: #57595a;
      font-weight: 400;
      margin: 0.3em 0em;
      padding: 0em;
    }
  }

  .bot__upload {
    display: grid;
    place-content: start;
    grid-auto-flow: row;
    margin: 0.5em 0em;

    label {
      color: #363939;
      font-weight: 500;
      margin-bottom: 1em;
    }

    .upload__box {
      border: dashed 1px #d2d3d3;
      display: grid;
      place-content: center;
      justify-content: center;
      padding: 1em 0em;
      cursor: pointer;

      input[type="file"] {
        left: 0;
        top: 0;
        opacity: 0;
        cursor: pointer;
      }

      img {
        width: 25px;
        height: 25px;
        place-self: center;
        margin-bottom: 0.8em;
      }

      label {
        color: #363939;
        font-weight: 000;
        text-align: center;
        padding: 0em;
      }

      caption {
        color: #57595a;
        font-weight: 400;
        text-align: center;
        padding: 0em;

        a {
          color: #1681ec;
          padding: 0em;
        }
      }
    }
  }

  button {
    background-color: #f2c046;
    color: #000000;
    padding: 0.8em;
    border-radius: 0.3em;
    border-style: none;
    margin-top: 2em;
    font-weight: 600;
  }
}

@media only screen and (max-width: 746px) {
  .card {
    &__icon {
      width: 3em;
      height: 3em;
      border-radius: 50px;
    }
    &__name {
      font-size: 0.8em;
      font-weight: 900;
    }
    &__text {
      font-size: 0.9em;
      padding: 0.5em;
    }
  }

  .loader {
    .bubble {
      &__text {
        font-size: 0.8em;
      }
    }
  }
  .cross {
    width: 2em;
    height: 2em;
    font-size: 1em;
  }
}
</style>
